<template>
  <!-- this is a loading demo usage -->
  <!-- maybe control loading status in App.vue and Vuex store -->
  <v-overlay :value="overlay">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>

<script>
// v-overlay doc: https://vuetifyjs.com/en/components/overlays/#loader
// v-progress0circular doc: https://vuetifyjs.com/en/components/progress-circular/#indeterminate

export default {
  data: () => ({
    overlay: true,
  }),
};
</script>

<style></style>
